export const faqsPl = [
  {
    q: "Czym różni się audyt kodu od modernizacji legacy?",
    a: "Audyt to ocena stanu i ryzyk (kod, architektura, infrastruktura) z raportem i rekomendacjami. Modernizacja to wdrożenie planu napraw: refaktor, migracja, hardening. Często to ta sama rozmowa w dwóch etapach — najpierw diagnoza, potem decyzja o zakresie prac.",
  },
  {
    q: "Co obejmuje audyt architektury aplikacji?",
    a: "Sprawdzamy granice modułów, zależności, sposób komunikacji między serwisami, skalowalność, bezpieczeństwo i koszt utrzymania zmian. Wynik: mapa ryzyk i propozycja kierunku (stabilizacja, refaktor wybranych obszarów albo większa modernizacja).",
  },
  {
    q: "Czy robicie audyt infrastruktury AWS / cloud?",
    a: "Tak — jako część tej samej oceny, gdy system stoi na AWS lub podobnym cloudzie: konta, sieci, uprawnienia, koszty, backupy, monitoring, CI/CD. Nie rozdzielamy „audytu kodu” i „audytu chmury”, jeśli problem leży na styku aplikacji i infrastruktury.",
  },
  {
    q: "Ile kosztuje i ile trwa audyt kodu?",
    a: "Zależnie od wielkości repo, liczby systemów i dostępu do dokumentacji. Typowy audyt aplikacji lub platformy to zwykle kilka–kilkanaście dni roboczych i wycena po krótkim scopingu. Po rozmowie podajemy widełki i listę materiałów wejściowych (repo, architektura, dostęp).",
  },
  {
    q: "Czy potrzebuję NDA przed audytem?",
    a: "Zazwyczaj tak. NDA przed dostępem do kodu, infrastruktury i danych produkcyjnych (nawet read-only) to standard — potem ustalamy zakres audytu i harmonogram.",
  },
  {
    q: "Czy po audycie musicie robić modernizację?",
    a: "Nie. Raport i plan napraw są wartością samą w sobie — możecie wdrożyć je in-house lub z innym partnerem. Często jednak kontynuujemy: stabilizacja, refaktor albo utrzymanie ze SLA po audycie.",
  },
  {
    q: "Kiedy modernizacja ma sens, a kiedy wystarczy utrzymanie?",
    a: "Jeśli awarie są rzadkie, a dług techniczny nie blokuje rozwoju — często wystarczy utrzymanie i punktowe poprawki. Modernizację proponujemy, gdy ryzyko, koszt zmian lub brak możliwości rozwoju przewyższają koszt refaktoru. Audyt właśnie to rozstrzyga.",
  },
  {
    q: "Czy audytujemy też systemy po innym wykonawcy?",
    a: "Tak — to częsty trigger. Audyt przed lub w trakcie przejęcia projektu pomaga ocenić jakość kodu, braki w CI/CD i realny koszt dalszego rozwoju. Jeśli szukacie samego handoveru operacyjnego, mamy też osobną ścieżkę przejęcia projektu.",
  },
] as const;
